module.exports = __webpack_public_path__ + "static/img/christina-wocintechchat-com-faEfWCdOKIg-unsplash.be3bf3a4.jpg";